export default [
    {
        path: "/prgrms",
        name: "programs",
        meta:{
            authRequired: true,
            title: "Programs",
            acc: ["v54"],
        },
        component: () => import("../views/programs/programs-list"),
    },
    {
        path: "/nwprgrms",
        name: "new-program",
        meta: {
            authRequired: true,
            title: "New Program",
            acc: ["v52"],
        },
        component: () => import("../views/programs/new"),
    },
    {
        path: "/oiungiest9tyneyteruiyt/:program?",
        name: "program",
        meta: {
            authRequired: true,
            title: "Program",
            acc: ["v5022113"],
        },
        component: () => import("../views/programs/view.vue"),
    },
    {
        path: "/oiungiest9tyneyteruiytadada/:program?",
        name: "edit-program",
        meta: {
            authRequired: true,
            title: "Edit Program",
            acc: ["v50"],
        },
        component: () => import("../views/programs/edit.vue"),
    },
]